<div class="apps-grid">
    <div class="grid-item app-card" *ngFor="let app of apps">
        <a [href]="buildLaunchUrl(app.APP_URL)" target="_blank" rel="noopener noreferrer" class="app-link">
            <img [src]="app.LOGO_URL" alt="{{ app.NAME }} Logo" class="app-image"/>
            <!-- <div class="app-name">{{ app.NAME }}</div> -->
        </a>
    </div>
</div>